import { 
  collection, query, where, getDocs 
} from 'firebase/firestore';
import { 
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut as firebaseSignOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth, db } from '../firebase/config';

// Lista de correos de administradores autorizados
const ADMIN_EMAILS = [
  'valgp1508@gmail.com',
  'pruebasminext@gmail.com',
  'goldencars333@gmail.com'
];

// Verificar si un email es de administrador
export const esAdmin = (email) => {
  return ADMIN_EMAILS.includes(email);
};

// Obtener lista de administradores
export const getAdminEmails = () => {
  return [...ADMIN_EMAILS];
};

// Login de administrador con email y contraseña
export const loginAdmin = async (email, password) => {
  try {
    if (!esAdmin(email)) {
      throw new Error('No tienes permisos de administrador');
    }
    
    const result = await signInWithEmailAndPassword(auth, email, password);
    console.log('Login exitoso como administrador:', result.user.email);
    
    return {
      type: 'admin',
      user: result.user,
      data: null
    };
  } catch (error) {
    console.error('Error en login admin:', error);
    if (error.code === 'auth/user-not-found') {
      throw new Error('Usuario no encontrado');
    } else if (error.code === 'auth/wrong-password') {
      throw new Error('Contraseña incorrecta');
    } else if (error.code === 'auth/invalid-credential') {
      throw new Error('Credenciales invalidas. Verifica tu email y contraseña');
    } else if (error.code === 'auth/invalid-email') {
      throw new Error('Email invalido');
    }
    throw error;
  }
};

// Enviar correo para restablecer contraseña
export const resetearPassword = async (email) => {
  try {
    if (!email) {
      throw new Error('Debes ingresar un correo electronico');
    }
    
    if (!esAdmin(email)) {
      throw new Error('Este servicio solo esta disponible para administradores autorizados');
    }
    
    await sendPasswordResetEmail(auth, email);
    console.log('Correo de restablecimiento enviado a:', email);
    return { success: true, message: 'Correo de restablecimiento enviado' };
  } catch (error) {
    console.error('Error al enviar correo de restablecimiento:', error);
    if (error.code === 'auth/user-not-found') {
      throw new Error('No existe una cuenta con este correo electronico');
    } else if (error.code === 'auth/invalid-email') {
      throw new Error('Correo electronico invalido');
    }
    throw error;
  }
};

// Login de cliente (documento + email) con verificación de pago
export const loginCliente = async (documento, email) => {
  console.log('Intentando login como cliente:', { documento, email });
  
  try {
    const q = query(
      collection(db, 'clientes'),
      where("email", "==", email),
      where("documento", "==", documento),
      where("activo", "==", true)
    );
    
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const clienteDoc = querySnapshot.docs[0];
      const clienteData = clienteDoc.data();
      
      // Verificar si el cliente ha realizado el pago
      if (!clienteData.pagoCompletado) {
        throw new Error('Para acceder a Mi Espacio debes completar el pago del servicio. Contacta a tu asesor para mas informacion.');
      }
      
      const cliente = {
        id: clienteDoc.id,
        ...clienteData,
        fechaRegistro: clienteData.fechaRegistro?.toDate()
      };
      console.log('Login exitoso como cliente:', cliente.nombre);
      return {
        type: 'cliente',
        user: null,
        data: cliente
      };
    }
    
    console.log('Cliente no encontrado');
    throw new Error('Documento y email no coinciden. Verifica tus datos.');
    
  } catch (error) {
    console.error('Error en login cliente:', error);
    throw error;
  }
};

// Cerrar sesión
export const logout = async () => {
  try {
    if (auth.currentUser) {
      await firebaseSignOut(auth);
    }
    sessionStorage.removeItem('usuario');
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
  }
};

// Verificar estado de autenticación
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    if (user && esAdmin(user.email)) {
      callback({
        type: 'admin',
        user: user,
        data: null
      });
    } else if (user) {
      firebaseSignOut(auth);
      callback(null);
    } else {
      callback(null);
    }
  });
};